module.exports = __webpack_public_path__ + "static/img/999.7b89f20c.jpg";